import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Form, FormGroup, Label, Input, Card, CardBody, Row, Col, Table } from "reactstrap";
import { authenticationService } from "services/authentication.service";
import { alertService } from 'components/Varios/alert_service'
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import Cargando from 'components/Varios/Cargando'
import { ObtenerAniosHistorialAutoridad, ObtenerHistorialAutoridad, ObtenerProyectoInstitucional, ObtenerProyectosInstitucionales, GuardarSolicitudProyectosInstitucionalesAutoridad, GuardarSolicitudProyectosInstitucionalesFirmadaAutoridad, ProyectosInstitucionalesVistaPreviaAutoridad, AnularSolicitudAutoridad, ObtenerNombreTitulo, EliminarSolicitudAutoridad } from './FunctionsProyectosInstitucionales'
import { ProyectoInstitucional, InformacionGeneralProyectosInstitucionales, PostProyectosInstitucionales, ViewContratoDTO } from "./TypesProyectosInstitucionales"
import TablaHistorialProyectosInstitucionalesAutoridad from "./TablaHistorialProyectosInstitucionalesAutoridad"
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalFirmarPDF from 'components/Varios/Modals/ModalFirmarPDF';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { GetDocumentVistaPrevia } from 'helpers/files';
import Swal from 'sweetalert2';
import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"
import SelectItem2 from '../../Varios/SelectNew';
import { ResponseRequest } from '../../Types/GeneralTypes';
import { PruebaSolucion3 } from '../../../functions/DatesFunctions';
import Datepicker from '../../Varios/Datepicker';
import { isWeekday } from 'functions/CalendarFunctions';
import TextEditor from '../../Varios/TextEditor.js';
import AsyncSelect from 'react-select/async';
import configData from "config.json";

type StateProyectosInstitucionales = {
    datosGenerales: InformacionGeneralProyectosInstitucionales,
    loading: boolean,
    mensajeError: string
}

type StateHistorialDetalle = {
    aniosDisponibles: number[],
    tabladetalle: Array<any>,
    loading: boolean,
    error: boolean,
    anioSeleccionado: number
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateInformacionModalRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string
}

type StateInformacionModalConfirmacion = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string,
    proyecto: ProyectoInstitucional,
    contrato: ViewContratoDTO
}

type stateModalFormulario = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined
    solicitudNueva?: PostProyectosInstitucionales
}

export default function ProyectosInstitucionalesAutoridad() {
    const defaultStateProyectosInstitucionales: StateProyectosInstitucionales = {
        datosGenerales: {
            tiposAmbito: [],
            tiposFuncion: [],
            tiposTermino: [],
            estructuraorganica: [],
            periodosacademicos: [],
            unidad: "",
            idunidad: 0,
            anio: -1
        },
        loading: false,
        mensajeError: "",
    }

    const defaultStateHistorialDetalle: StateHistorialDetalle = {
        aniosDisponibles: [],
        tabladetalle: [],
        loading: false,
        error: false,
        anioSeleccionado: -1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateInformacionModalRechazar: StateInformacionModalRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: ""
    }

    const defaultStateInformacionModalConfirmacion: StateInformacionModalConfirmacion = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: "",
        proyecto: {
            "idproyectosinstitucionales": 0,
            "idpersona": 0,
            "idestructuraorganica": 0,
            "nombreproyecto": "",
            "secuencia": "",
            "nroformulario": "",
            "nombreproyectocatalogo": "",
            "secuenciaautoridad": "",
            "nroformularioautoridad": "",
            "idestructuraorganicaresponsable": 0,
            "idambito": 0,
            "cargo": "",
            "idfuncion": 0,
            "descripcionfuncion": "",
            "idusario": 0,
            "refarchivo": "",
            "estado": "",
            "anio": "",
            "idtermino": 0,
            "fechadesde": "",
            "fechahasta": "",
            "horassemanales": 0,
            "horasanuales": 0,
            "cuerpocarta": "",
            "cuerpocartaautoridad": "",
            "refarchivoautoridad": "",
            "ingresoautoridad": "",
            "observacionrechazo": "",
            "actividades": ""
        },
        contrato: {
            "idpersona": 0,
            "nombres": "",
            "apellidos": "",
            "cargo": ""
        }
    }

    const defaultStateModalFormulario: stateModalFormulario = {
        url: "",
        loadingFormulario: false,
        tituloModal: ' ',
        content: undefined,
        solicitudNueva: undefined
    }

    const [getstateProyectosInstitucionales, setstateProyectosInstitucionales] = useState<StateProyectosInstitucionales>(defaultStateProyectosInstitucionales)
    const [getstateHistorialDetalle, setstateHistorialDetalle] = useState<StateHistorialDetalle>(defaultStateHistorialDetalle);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia);
    const [stateinformacionModalRechazar, setstateinformacionModalRechazar] = useState<StateInformacionModalRechazar>(defaultStateInformacionModalRechazar);
    const [stateinformacionModalEliminar, setstateinformacionModalEliminar] = useState<StateInformacionModalRechazar>(defaultStateInformacionModalRechazar);
    const [stateinformacionModalConfirmacion, setstateinformacionModalConfirmacion] = useState<StateInformacionModalConfirmacion>(defaultStateInformacionModalConfirmacion);
    const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario);
    const [errorFechas, seterrorFechas] = useState<string>("")
    const [inputValue, setValue] = useState<string>("");
    const [selectedValue, setSelectedValue] = useState(null);
    const [getNombreProfesor, setNombreProfesor] = useState<string>("");
    const [getNombreProfesorTitulo, setNombreProfesorTitulo] = useState<string>("");
    const [getUnidad, setUnidad] = useState<string>("")

    const PAO_1_PAO_2_PAE = 3861;
    const PAE_y_PAO_1 = 3862;
    const PAO_1_y_PAO_2 = 3863;
    const PAO_1 = 3864;
    const PAO_2 = 3865;
    const PAE = 3866;

    const COORDINADOR_OPCION = 3858;
    const RESPONSABLE_OPCION = 3859;
    const COORDINADOR_HORAS = 5;
    const RESPONSABLE_HORAS = 20;

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    function handleErrorInformacion(message?: string) {
        const mensaje = message ?? "Ha ocurrido un evento inesperado al intentar obtener información"
        alertService.error(mensaje)
    }

    async function ObtenerInformacionAniosHistorial() {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerAniosHistorialAutoridad();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial");
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, error: true })
        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado })
        }
    }

    async function ConsultarHistorial(stateHistorial: StateHistorialDetalle) {
        setstateHistorialDetalle({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorialAutoridad(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial")
            setstateHistorialDetalle({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...stateHistorial, tabladetalle: respuesta.dataResponse, loading: false })
        }
    }

    const onClickVerDoc = useCallback(async (referencia: string) => {
        setstateModalVP({ ...stateModalVP, loading: true })
        const datosUsuario: UserData = authenticationService.currentUserValue;
        const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
        setstateModalVP({ ...stateModalVP, loading: false, url })
    }, [stateModalVP])

    const GetHistorialByAnio = useCallback(async (anio: number) => {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerHistorialAutoridad(anio)

        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial")
            setstateHistorialDetalle({ ...getstateHistorialDetalle, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...getstateHistorialDetalle, tabladetalle: respuesta.dataResponse, loading: false, anioSeleccionado: anio })
        }
    }, [getstateHistorialDetalle])

    async function onClickVerDetalleProyecto(informacionAcciones) {
        var respuesta = await ObtenerProyectoInstitucional(informacionAcciones.idproyectosinstitucionales)
        if (respuesta.status === 200) {
            var objproyecto = respuesta.dataResponse.proyecto[0];
            var objcontrato = respuesta.dataResponse.contrato;
            var objfechainicio = respuesta.dataResponse.fechainicio;
            var objnombretitulo = respuesta.dataResponse.nombretitulo;

            setSelectedValue(objcontrato)
            setNombreProfesorTitulo(objnombretitulo)

            const modalContent = AuxiliarGenerarHTMLBodyEmpty();

            if (!objproyecto.ingresoautoridad && !objproyecto.cuerpocartaautoridad) {
                var txtfuncion = "";
                for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.tiposFuncion.length; i++) {
                    if (getstateProyectosInstitucionales.datosGenerales.tiposFuncion[i].idcatalogo === objproyecto.idfuncion) {
                        txtfuncion = getstateProyectosInstitucionales.datosGenerales.tiposFuncion[i].descripcion
                    }
                }

                var cuerpocarta = '<p style="text-align: justify;">Reciba un cordial saludo.\
                    En referencia al documento Nro. ' + objproyecto.nroformulario + ' designo a usted como ' + txtfuncion + ', del proyecto ' +
                    ' "' + objproyecto.nombreproyecto + '", funciones que asumirá desde el ' + objfechainicio + ', de acuerdo con los siguientes datos: \
                <br>\
                <br></p>';

                objproyecto.cuerpocartaautoridad = cuerpocarta;
            }

            setstateinformacionModalConfirmacion({
                cargando: false,
                idSolicitud: informacionAcciones.idproyectosinstitucionales,
                modalContent,
                observacion: "",
                proyecto: objproyecto,
                contrato: objcontrato
            })

        }
        else {
            alertService.error("Ha ocurrido un inconveniente al obtener la información")
        }
    }

    function AuxiliarGenerarHTMLBodyEmpty(): any {
        return (
            <>
                <div></div>
            </>
        )
    }

    const handleClickDesignaciondirecta = useCallback(
        function () {

            setstateinformacionModalConfirmacion(defaultStateInformacionModalConfirmacion)
            setSelectedValue(null)

            const modalContent = AuxiliarGenerarHTMLBodyEmpty();

            setstateinformacionModalConfirmacion({
                cargando: false,
                idSolicitud: 0,
                modalContent,
                observacion: "",
                proyecto: defaultStateInformacionModalConfirmacion.proyecto,
                contrato: defaultStateInformacionModalConfirmacion.contrato
            })

        }, [stateinformacionModalConfirmacion]
    );

    const maxLength = 350;
    const maxLengthCarta = 3000;

    const handleNombreChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            updatedModal.proyecto.nombreproyecto = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleNombreChange2 = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            updatedModal.proyecto.nombreproyecto = valor;
            updatedModal.proyecto.nombreproyectocatalogo = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleTipoAmbitoChange = (selectedOption: any) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.idambito = selectedOption;
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleEstructuraorganicaChange = (selectedOption: any) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.idestructuraorganicaresponsable = selectedOption;
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleNombreCatalogoChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            updatedModal.proyecto.nombreproyectocatalogo = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleCargoChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            updatedModal.proyecto.cargo = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleTipoFuncionChange = (selectedOption: any) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.idfuncion = selectedOption;

        if (selectedOption == COORDINADOR_OPCION)
            updatedModal.proyecto.horassemanales = COORDINADOR_HORAS
        else if (selectedOption == RESPONSABLE_OPCION)
            updatedModal.proyecto.horassemanales = RESPONSABLE_HORAS

        var cuerpocarta = handleactualizarcuerpodocumento(updatedModal);

        updatedModal.proyecto.cuerpocartaautoridad = cuerpocarta;

        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleInputChange = value => {
        setValue(value);
    };

    const handleChange = async value => {
        setSelectedValue(value);
        setNombreProfesor(value.apellidos + " " + value.nombres)
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.idpersona = value.idpersona;
        updatedModal.proyecto.cargo = value.cargo;
        setstateinformacionModalConfirmacion(updatedModal)

        const respuesta = await ObtenerNombreTitulo(value.idpersona)
        setNombreProfesorTitulo(respuesta.dataResponse.titulo)
    }

    const loadOptions = (inputValue) => {
        if (inputValue.length > 3) return fetch(`${configData.SERVER_URL}ProyectosInstitucionales/BuscarPersonaDocenteAutoridad/${inputValue}`).then(res => res.json()).then(result => result.entTabla);
        else return [];
    };

    const handlePeriodoAcademicoChange = (selectedOption: any) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.anio = selectedOption;
        updatedModal.proyecto.idtermino = 0;
        updatedModal.proyecto.fechadesde = "";
        updatedModal.proyecto.fechahasta = "";
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleTipoTerminoChange = (selectedOption: any) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        updatedModal.proyecto.idtermino = selectedOption;

        var fechaminima = new Date();
        var fechamaxima = new Date();
        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                    if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].min_fecha)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].max_fecha)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAE_y_PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin1)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio3)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                }
            }
        }

        updatedModal.proyecto.fechadesde = PruebaSolucion3(fechaminima);
        updatedModal.proyecto.fechahasta = PruebaSolucion3(fechamaxima);
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleFechaDesdeChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = PruebaSolucion3(event);
        updatedModal.proyecto.fechadesde = valor;
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleFechaHastaChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = PruebaSolucion3(event);
        updatedModal.proyecto.fechahasta = valor;
        setstateinformacionModalConfirmacion(updatedModal)
    };

    const handleHorasSemanalesChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value;
        if (!isNaN(valor)) {
            updatedModal.proyecto.horassemanales = Number(valor);
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleHorasAnualesChange = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        const valor = event.target.value;
        if (!isNaN(valor)) {
            updatedModal.proyecto.horasanuales = Number(valor);
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleHorasAnualesChange2 = (event) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        if (!isNaN(event)) {
            updatedModal.proyecto.horasanuales = Number(event);
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleHorasSemanalesChange2 = (event, event2) => {
        const updatedModal = { ...stateinformacionModalConfirmacion };
        if (!isNaN(event) && !isNaN(event2)) {
            updatedModal.proyecto.horassemanales = Number(event);
            updatedModal.proyecto.horasanuales = Number(event);
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleActividadesChange = (value) => {
        const valor = value;
        const updatedModal = { ...stateinformacionModalConfirmacion };
        if (valor.length <= maxLengthCarta) {
            updatedModal.proyecto.actividades = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleDescripcionFuncionChange = (value) => {
        const valor = value;
        const updatedModal = { ...stateinformacionModalConfirmacion };
        if (valor.length <= maxLengthCarta) {
            updatedModal.proyecto.descripcionfuncion = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const handleCuerpocartarectoradoChange = (value) => {
        const valor = value;
        const updatedModal = { ...stateinformacionModalConfirmacion };
        if (valor.length <= maxLengthCarta) {
            updatedModal.proyecto.cuerpocartaautoridad = valor;
            setstateinformacionModalConfirmacion(updatedModal)
        }
    };

    const DatePickerFechaDesde = useCallback(() => {
        var fechaminima = new Date();
        var fechamaxima = new Date();

        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                    if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].min_fecha)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].max_fecha)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAE_y_PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin1)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio3)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                }
            }
        }

        return (
            <Datepicker
                value={stateinformacionModalConfirmacion.proyecto.fechadesde}
                name="fechadesde"
                id="fechadesde"
                onChange={handleFechaDesdeChange}
                min={fechaminima}
                max={fechamaxima}
                filter={(datefilter: Date) => isWeekday(datefilter)}
                showDisabledMonthNavigation={true}
                required
            />
        )
    }, [getstateProyectosInstitucionales, stateinformacionModalConfirmacion, errorFechas])

    const DatePickerFechaHasta = useCallback(() => {
        var fechaminima = new Date();
        var fechamaxima = new Date();

        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                    if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].min_fecha)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].max_fecha)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAE_y_PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAE) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio1)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin1)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin2)
                    }
                    else if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_2) {
                        fechaminima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio3)
                        fechamaxima = new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3)
                    }
                }
            }
        }

        return (
            <Datepicker
                value={stateinformacionModalConfirmacion.proyecto.fechahasta}
                name="fechahasta"
                id="fechahasta"
                onChange={handleFechaHastaChange}
                min={fechaminima}
                max={fechamaxima}
                filter={(datefilter: Date) => isWeekday(datefilter)}
                showDisabledMonthNavigation={true}
                required
            />
        )
    }, [getstateProyectosInstitucionales, stateinformacionModalConfirmacion, errorFechas])

    useEffect(() => {
        if (stateinformacionModalConfirmacion.proyecto.fechadesde != undefined && stateinformacionModalConfirmacion.proyecto.fechahasta != undefined && stateinformacionModalConfirmacion.proyecto.fechadesde != "" && stateinformacionModalConfirmacion.proyecto.fechahasta != "") {
            var getFechadesde = new Date(stateinformacionModalConfirmacion.proyecto.fechadesde)
            var getFechahasta = new Date(stateinformacionModalConfirmacion.proyecto.fechahasta)
            if (getFechahasta.getTime() < getFechadesde.getTime()) {
                seterrorFechas("La fecha hasta no puede ser menor a la fecha desde")
            }
            else {
                seterrorFechas("")
            }
        }
        else {
            seterrorFechas("")
        }
    }, [stateinformacionModalConfirmacion, errorFechas])

    useEffect(() => {
        if (stateinformacionModalConfirmacion.proyecto.fechadesde != undefined && stateinformacionModalConfirmacion.proyecto.fechahasta != undefined && stateinformacionModalConfirmacion.proyecto.fechadesde != "" && stateinformacionModalConfirmacion.proyecto.fechahasta != "" && stateinformacionModalConfirmacion.proyecto.horassemanales != undefined && stateinformacionModalConfirmacion.proyecto.horassemanales.toString() != "") {
            var getFechadesde = new Date(stateinformacionModalConfirmacion.proyecto.fechadesde)
            var getFechahasta = new Date(stateinformacionModalConfirmacion.proyecto.fechahasta)
            if (getFechahasta.getTime() >= getFechadesde.getTime()) {
                var fechadesde = getFechadesde.getTime();
                var fechahasta = getFechahasta.getTime();
                var diff = fechahasta - fechadesde;
                var dias_milisegundos = 1000 * 60 * 60 * 24;

                for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
                    if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                        for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                            if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_y_PAO_2
                                && fechadesde === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2).getTime() && fechahasta === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3).getTime()) {
                                diff = 24192000000;
                            }
                        }
                    }
                }

                stateinformacionModalConfirmacion.proyecto.horasanuales = ((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(stateinformacionModalConfirmacion.proyecto.horassemanales))
                handleHorasAnualesChange2(stateinformacionModalConfirmacion.proyecto.horasanuales)
            }
            else {
                stateinformacionModalConfirmacion.proyecto.horasanuales = (0)
                handleHorasAnualesChange2(0)
            }
        }
    }, [stateinformacionModalConfirmacion.proyecto.fechadesde, stateinformacionModalConfirmacion.proyecto.fechahasta, stateinformacionModalConfirmacion.proyecto.horassemanales])

    useEffect(() => {
        if (stateinformacionModalConfirmacion.proyecto.horassemanales != undefined && Number(stateinformacionModalConfirmacion.proyecto.horassemanales) != 0) {

            if (stateinformacionModalConfirmacion.proyecto.idfuncion == COORDINADOR_OPCION && stateinformacionModalConfirmacion.proyecto.horassemanales <= COORDINADOR_HORAS) {
                var getFechadesde = new Date(stateinformacionModalConfirmacion.proyecto.fechadesde)
                var getFechahasta = new Date(stateinformacionModalConfirmacion.proyecto.fechahasta)
                if (getFechahasta.getTime() >= getFechadesde.getTime()) {
                    var fechadesde = getFechadesde.getTime();
                    var fechahasta = getFechahasta.getTime();
                    var diff = fechahasta - fechadesde;
                    var dias_milisegundos = 1000 * 60 * 60 * 24;

                    for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
                        if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                            for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                                if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_y_PAO_2
                                    && fechadesde === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2).getTime() && fechahasta === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3).getTime()) {
                                    diff = 24192000000;
                                }
                            }
                        }
                    }

                    stateinformacionModalConfirmacion.proyecto.horasanuales = ((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(stateinformacionModalConfirmacion.proyecto.horassemanales))
                    handleHorasAnualesChange2(stateinformacionModalConfirmacion.proyecto.horasanuales)
                }
                else {
                    stateinformacionModalConfirmacion.proyecto.horasanuales = (0)
                    handleHorasAnualesChange2(0)
                }
            }
            else if (stateinformacionModalConfirmacion.proyecto.idfuncion == RESPONSABLE_OPCION && stateinformacionModalConfirmacion.proyecto.horassemanales <= RESPONSABLE_HORAS) {
                var getFechadesde = new Date(stateinformacionModalConfirmacion.proyecto.fechadesde)
                var getFechahasta = new Date(stateinformacionModalConfirmacion.proyecto.fechahasta)
                if (getFechahasta.getTime() >= getFechadesde.getTime()) {
                    var fechadesde = getFechadesde.getTime();
                    var fechahasta = getFechahasta.getTime();
                    var diff = fechahasta - fechadesde;
                    var dias_milisegundos = 1000 * 60 * 60 * 24;

                    for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
                        if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === stateinformacionModalConfirmacion.proyecto.anio) {
                            for (let j = 0; j < getstateProyectosInstitucionales.datosGenerales.tiposTermino.length; j++) {
                                if (getstateProyectosInstitucionales.datosGenerales.tiposTermino[j].idcatalogo === stateinformacionModalConfirmacion.proyecto.idtermino && stateinformacionModalConfirmacion.proyecto.idtermino === PAO_1_y_PAO_2
                                    && fechadesde === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechainicio2).getTime() && fechahasta === new Date(getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].fechafin3).getTime()) {
                                    diff = 24192000000;
                                }
                            }
                        }
                    }

                    stateinformacionModalConfirmacion.proyecto.horasanuales = ((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(stateinformacionModalConfirmacion.proyecto.horassemanales))
                    handleHorasAnualesChange2(stateinformacionModalConfirmacion.proyecto.horasanuales)
                }
                else {
                    stateinformacionModalConfirmacion.proyecto.horasanuales = (0)
                    handleHorasAnualesChange2(0)
                }
            }
            else {
                stateinformacionModalConfirmacion.proyecto.horasanuales = (0)
                handleHorasSemanalesChange2(0, 0)
            }
        }
    }, [stateinformacionModalConfirmacion.proyecto.horassemanales, stateinformacionModalConfirmacion.proyecto.horasanuales])

    const contenidoModalConfirmacion: any = useMemo(() => {
        if (stateinformacionModalConfirmacion.cargando) {
            return <Cargando />
        }
        else if (stateinformacionModalConfirmacion.idSolicitud > 0 && !stateinformacionModalConfirmacion.proyecto.ingresoautoridad ) {
            const tabla =

                <>
                    <div className="content">

                        <Row>
                            <Col md={12} xl={12}>

                                <Card id="CardProyectosInstitucionales">
                                    <CardBody
                                        className="cardBodyContenedorProyectosInstitucionales"
                                        style={{ padding: "0px !important" }}
                                    >
                                        <div id="container-CBSolicitudes">
                                            <Row className="row-no-margin">
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombre"
                                                            className="label-permiso"
                                                        >
                                                            Nombre del proyecto*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.nombreproyecto}
                                                            maxLength={350}
                                                            id="nombre"
                                                            style={{ minHeight: "30px" }}
                                                            required
                                                            disabled={true}
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoAmbito"
                                                            className="label-permiso"
                                                        >
                                                            Ámbito del proyecto*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposAmbito.map((ambito) => ({
                                                                value: ambito.idcatalogo,
                                                                label: ambito.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoAmbito"
                                                            id="tipoAmbito"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idambito}
                                                            required
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="Estructuraorganica"
                                                            className="label-permiso"
                                                        >
                                                            Unidad responsable del proyecto*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.estructuraorganica.map((estructuraorganica) => ({
                                                                value: estructuraorganica.idestructuraorganica,
                                                                label: estructuraorganica.nombre,
                                                            }))}
                                                            placeholder=""
                                                            name="Estructuraorganica"
                                                            id="Estructuraorganica"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idestructuraorganicaresponsable}
                                                            onChange={handleEstructuraorganicaChange}
                                                            required
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombre"
                                                            className="label-permiso"
                                                        >
                                                            Nombre del proyecto para el catálogo*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo}
                                                            onChange={handleNombreCatalogoChange}
                                                            maxLength={350}
                                                            id="nombrecatalogo"
                                                            style={{ minHeight: "30px" }}
                                                            required
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={8} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombrepersona"
                                                            className="label-permiso"
                                                        >
                                                            Nombre*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.contrato.apellidos + " " + stateinformacionModalConfirmacion.contrato.nombres}
                                                            maxLength={350}
                                                            id="nombrepersona"
                                                            style={{ minHeight: "30px" }}
                                                            required
                                                            disabled={true}
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="cargo"
                                                            className="label-permiso"
                                                        >
                                                            Cargo*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.cargo}
                                                            onChange={handleCargoChange}
                                                            maxLength={350}
                                                            id="cargo"
                                                            style={{ minHeight: "30px" }}
                                                            disabled={true}
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoFuncion"
                                                            className="label-permiso"
                                                        >
                                                            Función a desempeñar*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposFuncion.map((funcion) => ({
                                                                value: funcion.idcatalogo,
                                                                label: funcion.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoFuncion"
                                                            id="tipoFuncion"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idfuncion}

                                                            required
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idanio"
                                                            className="label-permiso"
                                                        >
                                                            Año académico*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.periodosacademicos.map((periodo) => ({
                                                                value: periodo.anio,
                                                                label: periodo.min_anio + " - " + periodo.max_anio,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoPeriodo"
                                                            id="tipoPeriodo"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.anio}

                                                            required
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoTermino"
                                                            className="label-permiso"
                                                        >
                                                            Termino académico*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposTermino.map((termino) => ({
                                                                value: termino.idcatalogo,
                                                                label: termino.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoTermino"
                                                            id="tipoTermino"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idtermino}
                                                            onChange={handleTipoTerminoChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="fechadesde"
                                                            className="label-permiso"
                                                        >
                                                            Fecha desde*
                                                        </Label>
                                                        {DatePickerFechaDesde()}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="fechahasta"
                                                            className="label-permiso"
                                                        >
                                                            Fecha hasta*
                                                        </Label>
                                                        {DatePickerFechaHasta()}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idhorassemanales"
                                                            className="label-permiso"
                                                        >
                                                            Horas semanales*
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            step="1"
                                                            name="idhorassemanales"
                                                            id="idhorassemanales"
                                                            value={stateinformacionModalConfirmacion.proyecto.horassemanales}
                                                            onChange={handleHorasSemanalesChange}
                                                            required
                                                            style={{ minHeight: "30px" }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idhorasanuales"
                                                            className="label-permiso"
                                                        >
                                                            Horas anuales*
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            step="1"
                                                            name="idhorasanuales"
                                                            id="idhorasanuales"
                                                            value={stateinformacionModalConfirmacion.proyecto.horasanuales}
                                                            onChange={handleHorasAnualesChange}
                                                            required
                                                            style={{ minHeight: "30px" }}
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="rowErroresHoras">
                                                <Col xs={6}>

                                                </Col>
                                                <Col xs={6}>
                                                    <small className='small-error'>{errorFechas}</small>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="actividades"
                                                            className="label-permiso"
                                                        >
                                                            Actividades*
                                                        </Label>
                                                        <TextEditor
                                                            onChange={handleActividadesChange}
                                                            name="actividades"
                                                            value={stateinformacionModalConfirmacion.proyecto.actividades}
                                                            placeholder="Describa las actividades"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="cuerpocarta"
                                                            className="label-permiso"
                                                        >
                                                            Cuerpo del documento*
                                                        </Label>
                                                        <TextEditor
                                                            onChange={handleCuerpocartarectoradoChange}
                                                            name="cuerpocarta"
                                                            value={stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin text-center">
                                                <Button
                                                    onClick={() => handleClickGuardar()}
                                                    disabled={
                                                        !validarCamposProyectoInstitucional()
                                                    }
                                                >
                                                    GUARDAR{" "}
                                                </Button>
                                                <Button
                                                    onClick={() => handleClickFirmaryEnviar()}
                                                    disabled={
                                                        !validarCamposProyectoInstitucional()
                                                    }
                                                >
                                                    FIRMAR Y ENVIAR{" "}
                                                </Button>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </div>

                </>

            return tabla;
        }
        else if (stateinformacionModalConfirmacion.idSolicitud == 0 || (stateinformacionModalConfirmacion.idSolicitud > 0 && stateinformacionModalConfirmacion.proyecto.ingresoautoridad)) {
            const tabla =

                <>
                    <div className="content">

                        <Row>
                            <Col md={12} xl={12}>

                                <Card id="CardProyectosInstitucionales">
                                    <CardBody
                                        className="cardBodyContenedorProyectosInstitucionales"
                                        style={{ padding: "0px !important" }}
                                    >
                                        <div id="container-CBSolicitudes">
                                            <Row className="row-no-margin">
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombre"
                                                            className="label-permiso"
                                                        >
                                                            Nombre del proyecto*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.nombreproyecto}
                                                            onChange={handleNombreChange2}
                                                            maxLength={350}
                                                            id="nombre"
                                                            style={{ minHeight: "30px" }}
                                                            required
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoAmbito"
                                                            className="label-permiso"
                                                        >
                                                            Ámbito del proyecto*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposAmbito.map((ambito) => ({
                                                                value: ambito.idcatalogo,
                                                                label: ambito.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoAmbito"
                                                            id="tipoAmbito"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idambito}
                                                            onChange={handleTipoAmbitoChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="Estructuraorganica"
                                                            className="label-permiso"
                                                        >
                                                            Unidad responsable del proyecto*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.estructuraorganica.map((estructuraorganica) => ({
                                                                value: estructuraorganica.idestructuraorganica,
                                                                label: estructuraorganica.nombre,
                                                            }))}
                                                            placeholder=""
                                                            name="Estructuraorganica"
                                                            id="Estructuraorganica"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idestructuraorganicaresponsable}
                                                            onChange={handleEstructuraorganicaChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombre"
                                                            className="label-permiso"
                                                        >
                                                            Nombre del proyecto para el catálogo*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo}
                                                            onChange={handleNombreCatalogoChange}
                                                            maxLength={350}
                                                            id="nombrecatalogo"
                                                            style={{ minHeight: "30px" }}
                                                            required
                                                            disabled={true}
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={8} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="nombrepersona"
                                                            className="label-permiso"
                                                        >
                                                            Nombre*
                                                        </Label>

                                                        <AsyncSelect
                                                            cacheOptions
                                                            defaultOptions
                                                            placeholder="Buscar persona - Apellidos | Identificación"
                                                            loadingMessage={() => "Buscando . . ."}
                                                            noOptionsMessage={() => "No existe información para mostrar"}
                                                            value={selectedValue}
                                                            getOptionLabel={e => e.apellidos + " " + e.nombres}
                                                            getOptionValue={e => e.idpersona}
                                                            loadOptions={loadOptions}
                                                            onInputChange={handleInputChange}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="cargo"
                                                            className="label-permiso"
                                                        >
                                                            Cargo*
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            value={stateinformacionModalConfirmacion.proyecto.cargo}
                                                            maxLength={350}
                                                            id="cargo"
                                                            style={{ minHeight: "30px" }}
                                                            disabled={true}
                                                        ></Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoFuncion"
                                                            className="label-permiso"
                                                        >
                                                            Función a desempeñar*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposFuncion.map((funcion) => ({
                                                                value: funcion.idcatalogo,
                                                                label: funcion.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoFuncion"
                                                            id="tipoFuncion"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idfuncion}
                                                            onChange={handleTipoFuncionChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idanio"
                                                            className="label-permiso"
                                                        >
                                                            Año académico*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.periodosacademicos.map((periodo) => ({
                                                                value: periodo.anio,
                                                                label: periodo.min_anio + " - " + periodo.max_anio,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoPeriodo"
                                                            id="tipoPeriodo"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.anio}
                                                            onChange={handlePeriodoAcademicoChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="tipoTermino"
                                                            className="label-permiso"
                                                        >
                                                            Termino académico*
                                                        </Label>
                                                        <SelectItem2
                                                            options={getstateProyectosInstitucionales.datosGenerales.tiposTermino.map((termino) => ({
                                                                value: termino.idcatalogo,
                                                                label: termino.descripcion,
                                                            }))}
                                                            placeholder=""
                                                            name="tipoTermino"
                                                            id="tipoTermino"
                                                            icon="fa-caret-down"
                                                            value={stateinformacionModalConfirmacion.proyecto.idtermino}
                                                            onChange={handleTipoTerminoChange}
                                                            required
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="fechadesde"
                                                            className="label-permiso"
                                                        >
                                                            Fecha desde*
                                                        </Label>
                                                        {DatePickerFechaDesde()}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="fechahasta"
                                                            className="label-permiso"
                                                        >
                                                            Fecha hasta*
                                                        </Label>
                                                        {DatePickerFechaHasta()}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idhorassemanales"
                                                            className="label-permiso"
                                                        >
                                                            Horas semanales*
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            step="1"
                                                            name="idhorassemanales"
                                                            id="idhorassemanales"
                                                            value={stateinformacionModalConfirmacion.proyecto.horassemanales}
                                                            onChange={handleHorasSemanalesChange}
                                                            required
                                                            style={{ minHeight: "30px" }}
                                                            disabled={!(stateinformacionModalConfirmacion.proyecto.idfuncion == RESPONSABLE_OPCION)}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="idhorasanuales"
                                                            className="label-permiso"
                                                        >
                                                            Horas anuales*
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            step="1"
                                                            name="idhorasanuales"
                                                            id="idhorasanuales"
                                                            value={stateinformacionModalConfirmacion.proyecto.horasanuales}
                                                            onChange={handleHorasAnualesChange}
                                                            required
                                                            style={{ minHeight: "30px" }}
                                                            disabled={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="rowErroresHoras">
                                                <Col xs={6}>

                                                </Col>
                                                <Col xs={6}>
                                                    <small className='small-error'>{errorFechas}</small>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="actividades"
                                                            className="label-permiso"
                                                        >
                                                            Actividades*
                                                        </Label>
                                                        <TextEditor
                                                            onChange={handleActividadesChange}
                                                            name="actividades"
                                                            value={stateinformacionModalConfirmacion.proyecto.actividades}
                                                            placeholder="Describa las actividades"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="descripcionfuncion"
                                                            className="label-permiso"
                                                        >
                                                            Productos/resultados a entregar*
                                                        </Label>
                                                        <TextEditor
                                                            onChange={handleDescripcionFuncionChange}
                                                            name="descripcionfuncion"
                                                            value={stateinformacionModalConfirmacion.proyecto.descripcionfuncion}
                                                            placeholder="Describa los productos / resultados usando viñetas"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin">
                                                <Col md={2} className="pr-0">
                                                    <FormGroup>
                                                        <Label
                                                            for="cuerpocarta"
                                                            className="label-permiso"
                                                        >
                                                            Cuerpo del documento*
                                                        </Label>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3} className="pr-0">
                                                    <FormGroup>

                                                        <Button className="pull-left"
                                                            onClick={() => handleActualizarDocumento()}

                                                        >
                                                            REFRESCAR CUERPO DEL DOCUMENTO{" "}
                                                        </Button>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={12} className="pr-0">
                                                    <FormGroup>
                                                        <TextEditor
                                                            onChange={handleCuerpocartarectoradoChange}
                                                            name="cuerpocarta"
                                                            value={stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad}
                                                            placeholder="Cuerpo del documento"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row className="row-no-margin text-center">
                                                <Button
                                                    onClick={() => handleClickGuardar()}
                                                    disabled={
                                                        !validarCamposProyectoInstitucional()
                                                    }
                                                >
                                                    GUARDAR{" "}
                                                </Button>
                                                <Button
                                                    onClick={() => handleClickFirmaryEnviar()}
                                                    disabled={
                                                        !validarCamposProyectoInstitucional()
                                                    }
                                                >
                                                    FIRMAR Y ENVIAR{" "}
                                                </Button>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </div>

                </>

            return tabla;
        }

    }, [getstateProyectosInstitucionales, stateinformacionModalConfirmacion, errorFechas])

    const handleClickGuardar = useCallback(
        async function () {
            var titulo = "";
            var respuesta: ResponseRequest = { status: -1 };
            const formData = new FormData()
            //if (stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales === 0) {
            formData.append('idproyectosinstitucionales', stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales.toString())
            formData.append('nombreproyecto', stateinformacionModalConfirmacion.proyecto.nombreproyecto)
            formData.append('ambito', stateinformacionModalConfirmacion.proyecto.idambito.toString())
            formData.append('idestructuraorganica', stateinformacionModalConfirmacion.proyecto.idestructuraorganicaresponsable.toString())
            formData.append('nombreproyectocatalogo', stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo)
            formData.append('idpersona', stateinformacionModalConfirmacion.proyecto.idpersona.toString())
            formData.append('cargo', stateinformacionModalConfirmacion.proyecto.cargo)
            formData.append('funcion', stateinformacionModalConfirmacion.proyecto.idfuncion.toString())
            formData.append('descripcionfuncion', stateinformacionModalConfirmacion.proyecto.descripcionfuncion)
            formData.append('anio', stateinformacionModalConfirmacion.proyecto.anio)
            formData.append('termino', stateinformacionModalConfirmacion.proyecto.idtermino.toString())
            formData.append('fechadesde', stateinformacionModalConfirmacion.proyecto.fechadesde)
            formData.append('fechahasta', stateinformacionModalConfirmacion.proyecto.fechahasta)
            formData.append('horassemanales', stateinformacionModalConfirmacion.proyecto.horassemanales.toString())
            formData.append('horasanuales', stateinformacionModalConfirmacion.proyecto.horasanuales.toString())
            formData.append('cuerpocartaautoridad', stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad)
            formData.append('actividades', stateinformacionModalConfirmacion.proyecto.actividades)
            /*}
            else {
                formData.append('idproyectosinstitucionales', stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales.toString())
                formData.append('nombreproyectocatalogo', stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo)
                formData.append('termino', stateinformacionModalConfirmacion.proyecto.idtermino.toString())
                formData.append('fechadesde', stateinformacionModalConfirmacion.proyecto.fechadesde)
                formData.append('fechahasta', stateinformacionModalConfirmacion.proyecto.fechahasta)
                formData.append('horasanuales', stateinformacionModalConfirmacion.proyecto.horasanuales.toString())
                formData.append('horassemanales', stateinformacionModalConfirmacion.proyecto.horasmensuales.toString())
                formData.append('cuerpocartaautoridad', stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad)
            }*/

            respuesta = await GuardarSolicitudProyectosInstitucionalesAutoridad(formData);

            if (respuesta.status === 200) {

                await ObtenerInformacionAniosHistorial();
                setstateinformacionModalConfirmacion(defaultStateInformacionModalConfirmacion);
                await showAlert("Se ha guardado la solicitud", ExitoSVG, true);

                return respuesta.status;
            }

        }, [stateinformacionModalConfirmacion]
    );

    const handleClickFirmaryEnviar = useCallback(
        async () => {
            var titulo = "";
            var respuestaSolicitud: ResponseRequest = { status: -1 };
            let solicitudNueva: PostProyectosInstitucionales;

            solicitudNueva = {
                idproyectosinstitucionales: stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales,
                NombreProyecto: stateinformacionModalConfirmacion.proyecto.nombreproyecto,
                Ambito: stateinformacionModalConfirmacion.proyecto.idambito,
                idpersona: stateinformacionModalConfirmacion.proyecto.idpersona,
                idestructuraorganica: stateinformacionModalConfirmacion.proyecto.idestructuraorganicaresponsable,
                nombreproyectocatalogo: stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo,
                Cargo: stateinformacionModalConfirmacion.proyecto.cargo,
                Funcion: stateinformacionModalConfirmacion.proyecto.idfuncion,
                Descripcionfuncion: stateinformacionModalConfirmacion.proyecto.descripcionfuncion,
                Anio: stateinformacionModalConfirmacion.proyecto.anio,
                Termino: stateinformacionModalConfirmacion.proyecto.idtermino,
                Fechadesde: stateinformacionModalConfirmacion.proyecto.fechadesde,
                Fechahasta: stateinformacionModalConfirmacion.proyecto.fechahasta,
                HorasSemanales: stateinformacionModalConfirmacion.proyecto.horassemanales.toString(),
                HorasAnuales: stateinformacionModalConfirmacion.proyecto.horasanuales.toString(),
                Cuerpocarta: stateinformacionModalConfirmacion.proyecto.cuerpocarta,
                Cuerpocartaautoridad: stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad,
                Actividades: stateinformacionModalConfirmacion.proyecto.actividades
            }

            var respuesta: ResponseRequest = { status: -1 };
            const formData = new FormData()
            formData.append('idproyectosinstitucionales', stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales.toString())
            formData.append('nombreproyecto', stateinformacionModalConfirmacion.proyecto.nombreproyecto)
            formData.append('ambito', stateinformacionModalConfirmacion.proyecto.idambito.toString())
            formData.append('idestructuraorganica', stateinformacionModalConfirmacion.proyecto.idestructuraorganicaresponsable.toString())
            formData.append('nombreproyectocatalogo', stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo)
            formData.append('idpersona', stateinformacionModalConfirmacion.proyecto.idpersona.toString())
            formData.append('cargo', stateinformacionModalConfirmacion.proyecto.cargo)
            formData.append('funcion', stateinformacionModalConfirmacion.proyecto.idfuncion.toString())
            formData.append('descripcionfuncion', stateinformacionModalConfirmacion.proyecto.descripcionfuncion)
            formData.append('anio', stateinformacionModalConfirmacion.proyecto.anio)
            formData.append('termino', stateinformacionModalConfirmacion.proyecto.idtermino.toString())
            formData.append('fechadesde', stateinformacionModalConfirmacion.proyecto.fechadesde)
            formData.append('fechahasta', stateinformacionModalConfirmacion.proyecto.fechahasta)
            formData.append('horassemanales', stateinformacionModalConfirmacion.proyecto.horassemanales.toString())
            formData.append('horasanuales', stateinformacionModalConfirmacion.proyecto.horasanuales.toString())
            formData.append('cuerpocartaautoridad', stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad)
            formData.append('actividades', stateinformacionModalConfirmacion.proyecto.actividades)
            respuesta = await GuardarSolicitudProyectosInstitucionalesAutoridad(formData);
            if (respuesta.status === 200) {
                const updatedModal = { ...stateinformacionModalConfirmacion };
                updatedModal.proyecto.idproyectosinstitucionales = respuesta.dataResponse.idproyectosinstitucionales;
                setstateinformacionModalConfirmacion(updatedModal)
            }

            var content: any = "";
            respuestaSolicitud = await ProyectosInstitucionalesVistaPreviaAutoridad(solicitudNueva);
            setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })

        }, [stateinformacionModalConfirmacion]
    );

    function validarCamposProyectoInstitucional() {
        return stateinformacionModalConfirmacion.proyecto.nombreproyecto != undefined && stateinformacionModalConfirmacion.proyecto.nombreproyecto != "" && stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo != undefined && stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo.trim() != "" && errorFechas == "" && stateinformacionModalConfirmacion.proyecto.fechadesde != "" && stateinformacionModalConfirmacion.proyecto.fechahasta != ""
            && stateinformacionModalConfirmacion.proyecto.actividades != "" && stateinformacionModalConfirmacion.proyecto.actividades != "<p><br></p>" && stateinformacionModalConfirmacion.proyecto.descripcionfuncion != "" && stateinformacionModalConfirmacion.proyecto.descripcionfuncion != "<p><br></p>"
    }

    function onClickRechazarProyecto(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalRechazarProyecto(informacionAcciones);

        setstateinformacionModalRechazar({
            cargando: false,
            idSolicitud: informacionAcciones.idproyectosinstitucionales,
            modalContent,
            observacion: ""
        })
    }

    function AuxiliarGenerarHTMLBodyModalRechazarProyecto(informacionAcciones): any {
        return (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Nombre proyecto </th>
                            <th> Ámbito </th>
                            <th> Identificación</th>
                            <th> Nombres</th>
                            <th> Cargo</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombreproyecto}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.ambito}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.identificacion}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.cargo}
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </Table>
            </>
        )
    }

    async function RechazarSolicitud(idSolicitud, observacion) {
        const respuesta = await AnularSolicitudAutoridad(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            //OnCloseModalRechazo()
        }
        else {
            await showAlert("Se ha anulado la solicitud", ExitoSVG, true);
            //OnCloseModalRechazo()
        }
        return respuesta.status;
    }

    function onClickEliminarProyecto(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalRechazarProyecto(informacionAcciones);

        setstateinformacionModalEliminar({
            cargando: false,
            idSolicitud: informacionAcciones.idproyectosinstitucionales,
            modalContent,
            observacion: ""
        })
    }

    async function EliminarSolicitud(idSolicitud, observacion) {
        const respuesta = await EliminarSolicitudAutoridad(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
        }
        else {
            await showAlert("Se ha anulado la solicitud", ExitoSVG, true);
        }
        return respuesta.status;
    }

    async function OnCloseModalRechazo() {
        setstateinformacionModalRechazar(defaultStateInformacionModalRechazar);
        await ObtenerInformacionAniosHistorial();
    }

    async function OnCloseModalEliminar() {
        setstateinformacionModalEliminar(defaultStateInformacionModalRechazar);
        await ObtenerInformacionAniosHistorial();
    }

    async function OnCloseModalConfirmacion() {
        setstateinformacionModalConfirmacion(defaultStateInformacionModalConfirmacion);
        await ObtenerInformacionAniosHistorial();
    }

    const FirmarDocumentoSolicitud = async (objeto: any) => {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        var respuestaSolicitud: ResponseRequest = { status: -1 };

        if (contrasenia && filesData.length > 0) {
            var formData = new FormData();
            formData.append("contrasenia", contrasenia);
            filesData.map((fData) => {
                formData.append("files", fData.file, fData.file.name);
            });

            formData.append('idproyectosinstitucionales', stateinformacionModalConfirmacion.proyecto.idproyectosinstitucionales.toString())
            formData.append('nombreproyecto', stateinformacionModalConfirmacion.proyecto.nombreproyecto)
            formData.append('nombreproyectocatalogo', stateinformacionModalConfirmacion.proyecto.nombreproyectocatalogo)
            formData.append('ambito', stateinformacionModalConfirmacion.proyecto.idambito.toString())
            formData.append('idpersona', stateinformacionModalConfirmacion.proyecto.idpersona.toString())
            formData.append('idestructuraorganica', stateinformacionModalConfirmacion.proyecto.idestructuraorganica.toString())
            formData.append('cargo', stateinformacionModalConfirmacion.proyecto.cargo)
            formData.append('funcion', stateinformacionModalConfirmacion.proyecto.idfuncion.toString())
            formData.append('descripcionfuncion', stateinformacionModalConfirmacion.proyecto.descripcionfuncion)
            formData.append('anio', stateinformacionModalConfirmacion.proyecto.anio)
            formData.append('termino', stateinformacionModalConfirmacion.proyecto.idtermino.toString())
            formData.append('fechadesde', stateinformacionModalConfirmacion.proyecto.fechadesde.toString())
            formData.append('fechahasta', stateinformacionModalConfirmacion.proyecto.fechahasta.toString())
            formData.append('horassemanales', stateinformacionModalConfirmacion.proyecto.horassemanales.toString())
            formData.append('horasanuales', stateinformacionModalConfirmacion.proyecto.horasanuales.toString())
            formData.append('cuerpocartaautoridad', stateinformacionModalConfirmacion.proyecto.cuerpocartaautoridad)
            formData.append('actividades', stateinformacionModalConfirmacion.proyecto.actividades)

            respuestaSolicitud = await GuardarSolicitudProyectosInstitucionalesFirmadaAutoridad(formData);

            if (respuestaSolicitud.status === 200) {

                //await ObtenerInformacionAniosHistorial();
                await showAlert("Se ha firmado la solicitud", ExitoSVG, true);

                setstateModalFormulario(defaultStateModalFormulario)
                setstateinformacionModalConfirmacion(defaultStateInformacionModalConfirmacion)
                OnCloseModalConfirmacion()
            }
            else {
                await showAlert(respuestaSolicitud.errorMessage, ErrorSVG, false);
            }
        }
    }

    const handleActualizarDocumento = useCallback(
        async function () {
            const updatedModal = { ...stateinformacionModalConfirmacion };

            var cuerpocarta = handleactualizarcuerpodocumento(updatedModal);

            updatedModal.proyecto.cuerpocartaautoridad = cuerpocarta;

            setstateinformacionModalConfirmacion(updatedModal)

        }, [stateinformacionModalConfirmacion, getstateProyectosInstitucionales]
    );

    function handleactualizarcuerpodocumento(referencia: StateInformacionModalConfirmacion) {

        var txtfuncion = "";
        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.tiposFuncion.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.tiposFuncion[i].idcatalogo === referencia.proyecto.idfuncion) {
                txtfuncion = getstateProyectosInstitucionales.datosGenerales.tiposFuncion[i].descripcion
            }
        }

        var txtambito = "";
        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.tiposAmbito.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.tiposAmbito[i].idcatalogo === referencia.proyecto.idambito) {
                txtambito = getstateProyectosInstitucionales.datosGenerales.tiposAmbito[i].descripcion
            }
        }

        var txtunidadresponsable = "";
        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.estructuraorganica.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.estructuraorganica[i].idestructuraorganica === referencia.proyecto.idestructuraorganicaresponsable) {
                txtunidadresponsable = getstateProyectosInstitucionales.datosGenerales.estructuraorganica[i].nombre
            }
        }

        var txtanio = "";
        for (let i = 0; i < getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length; i++) {
            if (getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].anio === referencia.proyecto.anio) {
                txtanio = getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].min_anio + " - " + getstateProyectosInstitucionales.datosGenerales.periodosacademicos[i].max_anio
            }
        }

        var txtunidad = getstateProyectosInstitucionales.datosGenerales.unidad;

        var cuerpocarta = '<p style="text-align: justify;">Reciba un cordial saludo.\
                    Considerando la necesidad institucional de realizar proyectos de <b>' + txtambito + '</b>, ' +
            'alineados al plan Estratégico Institucional, designo a usted como "<b>' + txtfuncion + '</b>", titulado: "<b>' + referencia.proyecto.nombreproyectocatalogo + '</b>".\
            <br>\
            Por lo expuesto, estimado Decano (a) y Subdecano (a), ingresar en la Planificación Académica del año ' + txtanio + ', como responsable del proyecto o actividad institucional a ' + getNombreProfesorTitulo + ', debiendo informar a este ' + txtunidad + ' las gestiones realizadas por la responsabilidad asignada en este proyecto institucional.\
                <br>\
                <br></p>';

        return cuerpocarta;
    }

    async function GetDatosGenerales() {
        setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, loading: true });
        var respuesta = await ObtenerProyectosInstitucionales(handleErrorInformacion);
        if (respuesta.status === 200) {
            setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, datosGenerales: respuesta.dataResponse, loading: false });
        }
        else {
            setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, loading: false, mensajeError: respuesta.errorMessage ?? "" });
        }
    }

    useEffect(() => {
        GetDatosGenerales();
    }, [])

    useEffect(() => {
        ObtenerInformacionAniosHistorial();
    }, [])

    useEffect(() => {
        if (getstateHistorialDetalle.aniosDisponibles.length > 0) {
            ConsultarHistorial(getstateHistorialDetalle);
        }
    }, [getstateHistorialDetalle.aniosDisponibles])

    const TablaHistorialSolicitudesProyectosInstitucionales = useMemo(() => {
        if (getstateHistorialDetalle.loading) {
            return <Cargando />
        }
        else if (getstateHistorialDetalle.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!getstateHistorialDetalle.error && (getstateHistorialDetalle.aniosDisponibles.length === 0 && getstateHistorialDetalle.tabladetalle.length === 0)) {
            return <div className="row-no-margin">No hay historial de solicitudes por mostrar</div>
        }
        else if (!getstateHistorialDetalle.loading && getstateHistorialDetalle.tabladetalle.length > 0) {
            return (
                <TablaHistorialProyectosInstitucionalesAutoridad
                    anioSeleccionado={getstateHistorialDetalle.anioSeleccionado}
                    dataFilas={getstateHistorialDetalle.tabladetalle}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio={(anio: number) => GetHistorialByAnio(anio)}
                    onClickVerDetalle={async (solicitud: any) => await onClickVerDetalleProyecto(solicitud)}
                    onClickRechazar={(solicitud: any) => onClickRechazarProyecto(solicitud)}
                    onClickEliminar={(solicitud: any) => onClickEliminarProyecto(solicitud)}
                />
            )
        }
    }, [getstateHistorialDetalle]);

    const BotonDesignacionDirecta = useMemo(() => {
        if (getstateProyectosInstitucionales.loading) {
            return <Cargando />
        }
        else if (getstateProyectosInstitucionales.mensajeError) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!getstateProyectosInstitucionales.loading && getstateProyectosInstitucionales.datosGenerales.periodosacademicos.length > 0) {
            return (
                <Row>
                    <Col xs={3}>
                        <Button
                            onClick={() => handleClickDesignaciondirecta()}
                        >
                            DESIGNACIÓN DIRECTA DE RESPONSABILIDAD{" "}
                        </Button>
                    </Col>
                </Row>
            )
        }
    }, [getstateProyectosInstitucionales]);

    return (
        <div className='content'>
            <div className="titulo_seccion">
                Solicitudes para designaciones de responsabilidad en proyectos institucionales
            </div>

            {BotonDesignacionDirecta}

            {TablaHistorialSolicitudesProyectosInstitucionales}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento'
                urlArchivo={stateModalVP.url}
                botonCerrar={false}
            />

            <ModalRechazo
                show={stateinformacionModalRechazar.idSolicitud > 0 || stateinformacionModalRechazar.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazar(defaultStateInformacionModalRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarSolicitud(stateinformacionModalRechazar.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazar.modalContent}
                tituloModal={"Negar Solicitud"}
                asyncAfterOnClose={() => OnCloseModalRechazo()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />

            <ModalRechazo
                show={stateinformacionModalEliminar.idSolicitud > 0 || stateinformacionModalEliminar.cargando}
                size="lg"
                onClose={() => setstateinformacionModalEliminar(defaultStateInformacionModalRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea eliminar la solicitud?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarSolicitud(stateinformacionModalEliminar.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalEliminar.modalContent}
                tituloModal={"Eliminar Solicitud"}
                asyncAfterOnClose={() => OnCloseModalEliminar()}
                labelObservacion={"Indique el motivo para eliminar"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />

            <ModalConfirmacion
                show={stateinformacionModalConfirmacion.idSolicitud >= 0 || stateinformacionModalConfirmacion.cargando}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"Cerrar"}
                nombreBotonCerrarModal={"Cancelar"}
                onClose={() => setstateinformacionModalConfirmacion(defaultStateInformacionModalConfirmacion)}
                asyncAfterOnClose={() => OnCloseModalConfirmacion()}
                size={"xl"}
                classNameContentModal={"contentModalAprSolReintegroVacaciones"}
                contentModal={contenidoModalConfirmacion}
                classNameBotonCerrarModal={{ position: "absolute", zIndex: 9999, marginLeft: "40%" }}
                tituloModal={" "}
                classNameAllModal={""}
            />

            <ModalFirmarPDF
                show={(stateModalFormulario.url !== undefined && stateModalFormulario.url !== "") || stateModalFormulario.loadingFormulario}
                tituloModal='Solicitud para designación de responsable de Proyecto Institucional'
                admiteFirmaFisica={false}
                size="xl"
                urlArchivo={stateModalFormulario.url}
                onClose={() => setstateModalFormulario(defaultStateModalFormulario)}
                cargandoDatos={stateModalFormulario.loadingFormulario}
                onClickFirma={(objeto) => FirmarDocumentoSolicitud(objeto)}

            />
        </div>
    )
}